'use strict';

const _=require('pulsar-utils/dist-es6/_');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');let

FleetIncidentsPersonViewModel=class FleetIncidentsPersonViewModel extends PersonStatisticsViewModel{
constructor(...args){
super(...args);

const incidents=_.last(args);
_.ensureArrayOf(IncidentViewModel,incidents);
this._incidents=incidents;
}

get incidents(){
return this._incidents;
}};


module.exports=FleetIncidentsPersonViewModel;
//# sourceMappingURL=fleetIncidentsPersonViewModel.js.map
